import Repository from './../Repository';

const resource = 'admin/users';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    changeStatus(payload){return Repository.post(`${resource}/change/status`, payload);},
    update(payload, id) {return Repository.put(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    toggleStatus(id)    {return Repository.post(`${resource}/${id}/toggle/status`);},
    me()                {return Repository.get(`admin/me`);},
    meUpdate(payload)   {return Repository.put(`admin/me/update`, payload);},
    generateNewPassword(payload) {return Repository.post(`${resource}/generate/new/password`, payload);},
}